import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey } from '../client/queries/common'

/**
 * Refetches the errands list when one of the errand's documents reaches a terminal upload status.
 *
 * The errand carries its own copy of each document, so a document finishing has to be pulled in —
 * otherwise the timeline row would spin forever against stale fetched data. Status itself comes
 * live from RTDB (`useDocumentUploadStatus`); this only watches for the transition.
 */
export const useErrandsRefetchOnUploadSettled = (uploadStatuses: Record<string, string>) => {
  const queryClient = useQueryClient()
  const previous = useRef<Record<string, string>>({})

  useEffect(() => {
    const settled = Object.entries(uploadStatuses).some(([id, status]) => {
      const before = previous.current[id]

      return Boolean(before) && before !== status && (status === 'done' || status === 'error')
    })

    previous.current = uploadStatuses

    if (!settled) return

    queryClient.invalidateQueries({
      queryKey: [useErrandsServiceGetV1IndividualsByIndividualIdErrandsKey],
    })
  }, [uploadStatuses, queryClient])
}
